import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import '../styles/test-system.css';
import './TestCheckout.css';
import Navigation from '../components/Navigation';
import { cancelCheckout } from '../api/testSystem';
import { isAuthenticated } from '../utils/auth';

const XIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
);

const TestCheckoutCancelled = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id') || '';

    // "releasing" until the backend has expired the session; "held" if it could
    // not, which is not an error a candidate has to act on — Stripe's own expiry
    // releases the spot shortly after, and that clock is the primary one.
    const [state, setState] = useState(sessionId ? 'releasing' : 'released');
    const requested = useRef(false);

    useEffect(() => {
        if (!isAuthenticated()) {
            navigate('/login');
            return;
        }

        // Expiring a session is not idempotent enough to want it twice, and
        // StrictMode runs this effect twice in development.
        if (!sessionId || requested.current) return;
        requested.current = true;

        cancelCheckout(sessionId)
            .then(() => setState('released'))
            .catch((e) => {
                console.error('Error cancelling checkout session:', e);
                setState('held');
            });
    }, [navigate, sessionId]);

    return (
        <>
            <Navigation />
            <div className="ts-page">
                <div className="ts-shell ts-shell--narrow">
                    <section className="ts-panel ts-checkout" data-testid="checkout-cancelled">
                        <span className="ts-checkout-mark">
                            <XIcon />
                        </span>

                        <h1 className="ts-checkout-title">Checkout cancelled</h1>
                        <p className="ts-checkout-copy">
                            You have not been charged and nothing has changed on your account.
                        </p>

                        {state === 'releasing' ? (
                            <p className="ts-checkout-status" data-testid="checkout-releasing">
                                <span className="ts-spinner-sm" />
                                Releasing the spot that was being held…
                            </p>
                        ) : state === 'held' ? (
                            <p className="ts-checkout-status" data-testid="checkout-held">
                                Any spot that was being held for you is released automatically
                                within a few minutes.
                            </p>
                        ) : (
                            <p className="ts-checkout-status" data-testid="checkout-released">
                                Any spot that was being held for you is free again.
                            </p>
                        )}

                        <div className="ts-checkout-actions">
                            <Link className="ts-btn ts-btn--primary" to="/tests">Back to the catalog</Link>
                            <Link className="ts-btn" to="/tests/entries">Entries</Link>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default TestCheckoutCancelled;
